import http from "../../http-common";

export default class HubspotGetBasicUserInfo {
  getUserByEmail(email: string) {
    let url = `/hubspot/user?email=${encodeURIComponent(email)}`;

    return http.get(url);
  }
}